import { FETCH_POSDETAIL_FAILURE, FETCH_POSDETAIL_REQUEST, FETCH_POSDETAIL_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posPosDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_POSDETAIL_REQUEST:
            return {
                ...state,
            }
        case FETCH_POSDETAIL_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_POSDETAIL_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}